import React, { useState, useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid2';
import { Stack, Box, Typography } from '@mui/material';
import 'leaflet/dist/leaflet.css';
import 'maplibre-gl/dist/maplibre-gl.css';
import { useDataFromS3 } from '../hooks/useDataFromS3';
import '../style/legend_risk.css';
import { GRID_RANK } from '../const/grid'
import { CHRONOLOGY_VERTICAL_BAR_STACK_LEGEND } from '../const/legend'
import Pie from '../components/pie';
import MapChronology from '../components/map_chronology';
import VerticalBarStack from '../components/vertical_bar_stack'
import BarStack from '../components/bar_stack'
import DamageIncidents from '../item/damage_incidents_txt';
import CommonCard from '../item/common_card';
import Proggress from '../item/progress'
import HeaderSub from '../item/header_sub'
import { setChronologyLevelColor } from '../func/color';
import { useLocation } from 'react-router-dom';
import {
    getTimeAry, getKeyNameCountByDateTime, getChronologyRankWithLimit,
    getChronologyTimeRankWithLimit, getChronologyPieData, getAllByMshCode, getAllByMshCodeNotNull
} from '../func/util'
import choropleth_msh from '../data/msh.json';

const Chronology = (props) => {
    const [dateArray, setDateArray] = useState(null);
    const [shouldFetch, setShouldFetch] = useState(false);
    // クロノロジー
    const [chronologyList, setChronologyList] = useState(null);
    const [mainDamageVal, setMainDamageVal] = useState(null);
    const [finishVal, setFinishVal] = useState(null);
    const [ongoingVal, setOngoingVal] = useState(null);
    const [pieValueData, setPieValueData] = useState(null);
    const [pieLabelData, setPieLabelData] = useState(null);
    const [chronologyDateData, setChronologyDateData] = useState(null);
    const [chronologyCityData, setChronologyCityData] = useState(null);
    const [selectLabelChronology, setSelectLabelChronology] = useState(null);
    const [selectTimeTmsChronology, setSelectTimeTmsChronology] = useState(null);

    const location = useLocation();
    const prevDatetimeRef = useRef(null);

    // 全データ再取得の要否を定期監視する
    const {
        data: datetimeLatest,
        loading: datetimeLatestLoading,
        error: datetimeLatestError,
    } = useDataFromS3(`api/get_datetime_latest`);

    // サーバーの最終更新日時が変更されているか判定
    useEffect(() => {
        if (datetimeLatest && JSON.stringify(datetimeLatest) !== JSON.stringify(prevDatetimeRef.current)) {
            prevDatetimeRef.current = datetimeLatest;
            setShouldFetch(true); // dataが変わったらメインデータを取得
        } else {
            setShouldFetch(false); // dataが変わってないならメインデータを取得しない
        }
    }, [datetimeLatest]);

    let msh_chronology_url = null
    let risk_status_url = null

    if (shouldFetch) {
        msh_chronology_url = `api/get_chr_analized`;
        risk_status_url = `api/get_risk_status`;
    }

    // reload page when change pathname
    useEffect(() => {
        prevDatetimeRef.current = null
    }, [location.pathname])

    // クロノロジーデータを取得
    const {
        data: mshChronologyData,
        loading: mshChronologyLoading,
        error: mshChronologyError,
    } = useDataFromS3(msh_chronology_url);

    // 災害情報を取得
    const {
        data: riskStatusData,
        loading: riskStatusLoading,
        error: riskStatusError
    } = useDataFromS3(risk_status_url);

    // ランキングデータ取得
    const getRankData = (data, isOver, sliderValueRef, getLabelValue, getYValue) => {
        let rankData = data;
        if (isOver) {
            // 取得されたリスクの最大値を並べ替え（昇順/低い順）
            rankData.sort((a, b) => {
                if (a.total !== b.total) {
                    return a.total - b.total;
                }
                return String(a.city_code).localeCompare(String(b.city_code));
            })
        } else {
            // 取得されたリスクの最大値を並べ替え（降順/高い順）
            rankData.sort((a, b) => {
                if (a.total !== b.total) {
                    return b.total - a.total;
                }
                return String(a.city_code).localeCompare(String(b.city_code));
            })
        }

        // sliderValueに応じてリスクの最大値を並べ替え
        let series_ary = []
        let category_ary = []
        if (isOver) {
            for (let i = sliderValueRef.current[1]; i > sliderValueRef.current[0] - 1; i--) {
                if (rankData.length > i) {
                    series_ary.push({
                        x: '',
                        y: rankData[i].total,
                        custom: {
                            city_name: rankData[i].city_name,
                            city_code: rankData[i].city_code,
                            area_lng: rankData[i].area_lng,
                            area_lat: rankData[i].area_lat,
                            total: rankData[i].total
                        }
                    })
                    category_ary.push(rankData[i].city_name)
                }
            }
        } else {
            data.map(item => {
                series_ary.push({
                    x: '',
                    y: item.total,
                    custom: {
                        city_name: item.city_name,
                        city_code: item.city_code,
                        area_lng: item.area_lng,
                        area_lat: item.area_lat,
                        total: item.total
                    }
                })
                category_ary.push(item.city_name)
            })
        }
        return { rankData, series_ary, category_ary };
    }

    // ランキングデータ取得
    const getRankDataTime = (data, isOver, sliderValueRef, getLabelValue, getYValue) => {
        let rankData = Array.isArray(data) ? [...data] : [];

        const parseDate = (d) => {
            if (d === null || d === undefined) return 0;
            let t = Date.parse(d);
            if (isNaN(t)) {
                const year = new Date().getFullYear();
                t = Date.parse(`${year}/${d}`);
            }
            return isNaN(t) ? 0 : t;
        };

        // 日時の早い順（昇順）にソート
        rankData.sort((a, b) => parseDate(a.date) - parseDate(b.date));

        let series_ary = [];
        let category_ary = [];

        if (isOver) {
            for (let i = sliderValueRef.current[1]; i > sliderValueRef.current[0] - 1; i--) {
                if (rankData.length > i) {
                    series_ary.push({
                        x: '',
                        y: rankData[i].total,
                        custom: {
                            city_name: rankData[i].city_name,
                            city_code: rankData[i].city_code,
                            area_lng: rankData[i].area_lng,
                            area_lat: rankData[i].area_lat,
                            total: rankData[i].total,
                            date: rankData[i].date,
                            codes: rankData[i].codes
                        }
                    });
                    category_ary.push(rankData[i].date);
                }
            }
        } else {
            rankData.map(item => {
                series_ary.push({
                    x: '',
                    y: item.total,
                    custom: {
                        city_name: item.city_name,
                        city_code: item.city_code,
                        area_lng: item.area_lng,
                        area_lat: item.area_lat,
                        total: item.total,
                        date: item.date,
                        codes: item.codes
                    }
                });
                category_ary.push(item.date);
            });
        }
        return { rankData, series_ary, category_ary };
    };

    // ランキングクリック時の動作
    const verticalBarClickEvent = (clickedItem) => {
        props.setSelectSubCity([clickedItem.custom.city_code])
    }

    // ランキングのカラー（土砂）
    const getRankColor = (value, series, seriesIndex, dataPointIndex) => {
        return setChronologyLevelColor(series[seriesIndex].name)
    }

    const toZenkakuAll = (str) => {
        return str
            .replace(/[0-9A-Za-z]/g, s => String.fromCharCode(s.charCodeAt(0) + 0xFEE0)) // 半角英数字 → 全角
            .replace(/,/g, '、')         // 半角カンマ → 全角カンマ
            .replace(/ /g, '　')         // 半角スペース → 全角スペース
            .replace(/\(/g, '（')        // 半角( → 全角（
            .replace(/\)/g, '）');       // 半角) → 全角）
    };

    // ランキングのラベルフォーマット
    const getLabelFormat = (value) => {
        const str = toZenkakuAll(String(value));
        // 8文字以上は省略
        if (str.length >= 8) {
            return str = str.slice(0, 3) + '…' + str.slice(-4);
        }
        return '　'.repeat(8 - str.length) + str;
    }

    // ランキングのX軸ツールチップフォーマット
    const tooltipFormatX = (opts) => {
        return '';
    }

    // ランキングのY軸ツールチップフォーマット
    const tooltipFormatY = (val) => {
        return String(val);
    }

    // ランキングのY軸ツールチップフォーマット
    const tooltipFormatCustom = (opts, areaNameAry, areaRiverNameAry) => {
        const value = opts.series[opts.seriesIndex][opts.dataPointIndex];
        const seriesName = opts.w.globals.seriesNames[opts.seriesIndex];

        return `<div style="padding: 4px 8px; font-size: 12px;">
                    ${seriesName}: ${value}
                </div>`;
    }

    // データ整備用のパラメータを取得
    const getParams = (keyAry, keyName = '') => {
        const features_msh = choropleth_msh.features;

        // --- メッシュデータ取得 (ここを配列対応に修正) ---
        const keySet = new Set(keyAry.map(String));
        const allFilteredMsh = features_msh.filter(f =>
            keySet.has(String(f.properties[keyName]))
        );

        let masterMshFeatures = [];

        // 選択時と初期表示時の切り分け
        if (keyAry.length === 1 && allFilteredMsh.length > 0 && keyName !== 'city_code') {
            // 地図選択時：最初の1件に絞り込み、その中のarea_codeも最初の1つにする
            // ランキング等でcity_code選択時は複数字がある可能性があるためこの処理は行わない
            const firstMsh = allFilteredMsh[0];

            masterMshFeatures = [{
                ...firstMsh,
                properties: {
                    ...firstMsh.properties,
                }
            }];
        } else {
            // 初期表示時：全データをそのまま使用
            masterMshFeatures = allFilteredMsh;
        }

        // --- メッシュコード配列取得 ---
        let msh_code_ary = masterMshFeatures.map(feature => feature.properties.id);

        return {
            msh_code_ary, masterMshFeatures
        };
    }

    // ローディング開始
    const startLoading = () => {
        props.setReady(prev => {
            const updated = Object.fromEntries(
                Object.keys(prev).map(key => [key, false])
            );
            return updated;
        });
        setSelectLabelChronology(null);
        setSelectTimeTmsChronology(null);
    }

    useEffect(() => {
        // ローディング開始
        startLoading()
        const fetchData = async () => {
            let params_obj = {}
            let date_ary = []

            let msh_chronology_all_datetime = []
            let chronology_main_damage_num = []
            let chronology_finish_num = []
            let chronology_ongoing_num = []
            let chronology_date_data = []
            let chronology_city_data = []
            let chronology_value_data = []
            let chronology_label_data = []

            if (props.selectMsh && Array.isArray(props.selectMsh)
                && props.selectMsh.length > 0) {
                params_obj = getParams(props.selectMsh, 'id')
            } else if (props.selectSubCity && Array.isArray(props.selectSubCity)
                && props.selectSubCity.length > 0) {
                params_obj = getParams(props.selectSubCity, 'city_code')
            } else {
                params_obj = getParams(props.selectCitys, 'city_code')
            }

            if (Object.keys(params_obj).length > 0) {
                // 日時の配列を取得
                date_ary = getTimeAry(datetimeLatest, props.h6Switch)

                // メッシュコードごとのクロノロジーのオブジェクト配列を取得
                // [{ code: 503021111（メッシュコード）, 
                msh_chronology_all_datetime = getAllByMshCode(params_obj.msh_code_ary, mshChronologyData, false)
                msh_chronology_all_datetime = getAllByMshCodeNotNull(msh_chronology_all_datetime);
                if (selectLabelChronology) {
                    msh_chronology_all_datetime = msh_chronology_all_datetime.filter(item => String(item.TXT_MAIN_DAMAGE_NAME || item.txt_main_damage_name) === String(selectLabelChronology));
                }
                if (selectTimeTmsChronology) {
                    msh_chronology_all_datetime = msh_chronology_all_datetime.filter(item => String(item.TMS_UPDATE_DATE_SUM || item.tsm_update_date_sum) === String(selectTimeTmsChronology));
                }
                if (msh_chronology_all_datetime.length > 0) {
                    // 被害情報発生件数用のデータ
                    chronology_main_damage_num = getKeyNameCountByDateTime(msh_chronology_all_datetime, 'int_main_damage_num');
                    // 対処済件数用のデータ
                    chronology_finish_num = getKeyNameCountByDateTime(msh_chronology_all_datetime, 'int_finished_num');
                    // 対処中件数用のデータ
                    chronology_ongoing_num = getKeyNameCountByDateTime(msh_chronology_all_datetime, 'int_ongoing_num');
                    /// 被害情報割合用のデータ
                    chronology_label_data = getChronologyPieData(msh_chronology_all_datetime).labels;
                    chronology_value_data = getChronologyPieData(msh_chronology_all_datetime).values;
                    // 市町村ごとの被害情報分析用のデータ
                    chronology_city_data = getChronologyRankWithLimit(msh_chronology_all_datetime, 200);
                    // 更新日時ごとの被害情報件数用のデータ
                    chronology_date_data = getChronologyTimeRankWithLimit(msh_chronology_all_datetime, 200);
                }
            }

            // クロノロジーデータ
            setChronologyList(msh_chronology_all_datetime.length > 0 ? msh_chronology_all_datetime : null)
            // 被害情報発生件数
            setMainDamageVal(chronology_main_damage_num)
            // 対処済件数
            setFinishVal(chronology_finish_num)
            // 対処中件数
            setOngoingVal(chronology_ongoing_num)
            //　被害情報割合
            setPieValueData(chronology_value_data.length > 0 ? chronology_value_data : null)
            setPieLabelData(chronology_label_data.length > 0 ? chronology_label_data : null)
            // 市町村ごとの被害情報分析
            setChronologyCityData(chronology_city_data.length > 0 ? chronology_city_data : null)
            // 更新日時ごとの被害情報件数
            setChronologyDateData(chronology_date_data.length > 0 ? chronology_date_data : null)

            // 日時
            setDateArray(date_ary.length > 0 ? date_ary : null)
        };
        if (datetimeLatest && mshChronologyData && riskStatusData) {
            fetchData();
        }
    }, [datetimeLatest,
        mshChronologyData,
        riskStatusData,
        props.selectCitys, props.selectSubCity, props.selectMsh,
        props.h6Switch
    ]);

    if (datetimeLatestLoading || datetimeLatest === undefined
        || (datetimeLatestError && datetimeLatestError.message.includes("Received HTML"))
        || mshChronologyLoading || mshChronologyData === undefined
        || (mshChronologyError && mshChronologyError.message.includes("Received HTML"))
        || riskStatusLoading || riskStatusData === undefined
        || (riskStatusError && riskStatusError.message.includes("Received HTML"))
    ) {
        // Loading表示
        return <Proggress />
    }

    if (datetimeLatestError
        || mshChronologyError
        || riskStatusError
    ) {
        return (
            <>
                <Typography
                    sx={{
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        color: 'white'
                    }}
                >
                    申し訳ございません、データ取得に失敗しました。
                </Typography>
                <Typography
                    sx={{
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        color: 'white'
                    }}
                >
                    恐れ入りますが、しばらく時間をおいてから再度お試しください。
                </Typography>
            </>
        )
    }

    return (
        <>
            <Box
                sx={{
                    // グローバルヘッダーの「36px」と時刻表示分の「17px」、大枠のGridのマージン上下「8px」ずつを差し引きく
                    height: { xs: '100%', sm: 'calc(100dvh - 36px - 17px - 8px - 8px)' }, // 親が高さを持つ
                    boxSizing: 'border-box'
                }}
            >
                <HeaderSub
                    pageTitle={""}
                    riskStatus={riskStatusData[0].status}
                    dateTime={datetimeLatest && datetimeLatest[12]}
                />
                <Grid container
                    spacing={0}
                    columns={12}
                    sx={{ height: '100%', width: '100%', padding: 0, m: 0 }} // Grid全体の高さ100%
                >
                    <Grid size={{ xs: 12, sm: 12, md: 8 }} container spacing={0}>
                        <Grid size={{ xs: 12, sm: 12, md: 5 }} container direction="column">
                            <Stack spacing={0}>
                                {/* テキスト */}
                                <DamageIncidents
                                    titleDamageIncidents={"被害情報発生件数"}
                                    titleResolved={"対処済件数"}
                                    titleInProgress={"対処中件数"}
                                    mainDamageVal={mainDamageVal}
                                    finishVal={finishVal}
                                    ongoingVal={ongoingVal}
                                    height={'calc(10dvh - (36px * 0.1) - (17px * 0.1) - (8px * 0.1) - (8px * 0.1) - 31px - 5px)'}
                                />
                                {/* 円グラフ */}
                                <CommonCard
                                    child={
                                        <Pie
                                            setSelectMsh={props.setSelectMsh}
                                            setSelectLabelChronology={setSelectLabelChronology}
                                            valueData={pieValueData}
                                            labelData={pieLabelData}
                                            chronologyList={chronologyList}
                                            dateArray={dateArray}
                                            isReadyKey={['pie_chronology']}
                                            isReadyFlg={props.isReady.pie_chronology}
                                            setReady={props.setReady}
                                        />}
                                    title={"被害情報割合"}
                                    xsHeight="200px"
                                    height='calc(45dvh - (36px * 0.45) - (17px * 0.45) - (8px * 0.45) - (8px * 0.45) - 31px - 5px)'
                                />
                            </Stack>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 7 }}>
                            {/* マップ */}
                            <CommonCard
                                child={
                                    <MapChronology
                                        selectCitys={props.selectCitys}
                                        setSelectMsh={props.setSelectMsh}
                                        riskMapZoom={props.riskMapZoom}
                                        riskMapCenter={props.riskMapCenter}
                                        chronologyList={chronologyList}
                                        setSelectLabelChronology={setSelectLabelChronology}
                                    />
                                }
                                title={"被害情報分析"}
                                xsHeight="300px"
                                height='calc(65dvh - (36px * 0.65) - (17px * 0.65) - (8px * 0.65) - (8px * 0.65) - 31px - 5px)'
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                            <Stack spacing={0} >
                                {/* 縦棒グラフ */}
                                <CommonCard
                                    child={
                                        <BarStack
                                            distance={200}
                                            limitVal={0}
                                            allRankData={chronologyDateData}
                                            dateArray={dateArray}
                                            getRankData={getRankDataTime}
                                            setSelectMsh={props.setSelectMsh}
                                            plusValue={1}
                                            setSelectTimeTmsChronology={setSelectTimeTmsChronology}
                                            getRankColor={getRankColor}
                                            fontSize={'12px'}
                                            enabled={true}
                                            tooltipFormatX={tooltipFormatX}
                                            tooltipFormatY={tooltipFormatY}
                                            tooltipFormatCustom={tooltipFormatCustom}
                                            isReadyKey={['bar_chronology']}
                                            isReadyFlg={props.isReady.bar_chronology}
                                            setReady={props.setReady}
                                        />
                                    }
                                    title={"更新日時ごとの被害情報件数"}
                                    xsHeight="200px"
                                    height='calc(35dvh - (36px * 0.35) - (17px * 0.35) - (8px * 0.35) - (8px * 0.35) - 31px - 5px)'
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                            {/* 横棒グラフ */}
                            <CommonCard
                                child={
                                    <>
                                        {CHRONOLOGY_VERTICAL_BAR_STACK_LEGEND()}
                                        <VerticalBarStack
                                            distance={100}
                                            limitVal={0}
                                            grid={GRID_RANK}
                                            allRankData={chronologyCityData}
                                            dateArray={dateArray}
                                            getRankData={getRankData}
                                            plusValue={1}
                                            verticalBarClickEvent={verticalBarClickEvent}
                                            getRankColor={getRankColor}
                                            fontSize={'12px'}
                                            maxWidth={100}
                                            getLabelFormat={getLabelFormat}
                                            enabled={true}
                                            tooltipFormatX={tooltipFormatX}
                                            tooltipFormatY={tooltipFormatY}
                                            tooltipFormatCustom={tooltipFormatCustom}
                                            height={'calc(100% - 70px)'}
                                            isReadyKey={['vertical_bar_chronology']}
                                            isReadyFlg={props.isReady.vertical_bar_chronology}
                                            setReady={props.setReady}
                                        />
                                    </>
                                }
                                title={"市町村ごとの被害情報分析"}
                                xsHeight="400px"
                                height='calc(100dvh - (36px * 1.0) - (17px * 1.0) - (8px * 1.0) - (8px * 1.0) - 31px - 5px)'
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Box >
        </>
    )
}
export default Chronology;